import { IntlProvider } from 'react-intl';
import { useEnglishMessages } from './LocaleContext';

// Identity-stable fallback while the EN catalog chunk lands (defaultMessage covers the gap).
const EMPTY = {};

/**
 * Pre-sign-in pages are English, always. Pages that can hold a live session
 * before the user is fully in the app (Login during 2FA, ResetPassword and
 * AcceptInvite after token verification) would otherwise follow the signed-in
 * user's saved language. Nested IntlProvider pins them to English.
 */
export default function PreAuthEnglish({ children }) {
  const messages = useEnglishMessages();
  return (
    <IntlProvider locale="en" messages={messages || EMPTY} defaultLocale="en">
      {children}
    </IntlProvider>
  );
}

/** Wrap a page component in PreAuthEnglish. Call once at module level (stable reference). */
export function withPreAuthEnglish(Page) {
  function PreAuthEnglishPage(props) {
    return (
      <PreAuthEnglish>
        <Page {...props} />
      </PreAuthEnglish>
    );
  }
  PreAuthEnglishPage.displayName = `PreAuthEnglish(${Page.displayName || Page.name || 'Page'})`;
  return PreAuthEnglishPage;
}
